module.exports = __webpack_public_path__ + "media/images/signatures/2024/laci-9853d943d91f0b03e86eba390b704d76.png";